<div class="p-4">
  <div class="container">
    <h1>Hi {{ account.firstName }}!</h1>
    <!-- <p>You're logged in to Tessellon!</p> -->
    @if (hasApplicationRoles()) {
      <div id="myApplications" style="margin-top: 1rem;">
        <h3>My Applications</h3>
        <br />
        <app-portal-cards [isMyApplication]="true"></app-portal-cards>
      </div>
    }
    @if (hasAvailableApplications()) {
      <div id="availableApplications" style="margin-top: 1rem;">
        <h3>Available Applications</h3>
        <br />
        <app-portal-cards [isMyApplication]="false"></app-portal-cards>
      </div>
    }
  </div>
</div>
